import { OnboardingDetailsRole, Relation } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { phoneValidation, requiredDialCode, requiredEmail, requiredPhoneNumber } from '@/utils/zodUtils';

export const ContactDataFormSchema = (t: GetTextIdTranslationType, selectedRole?: OnboardingDetailsRole) =>
  z
    .object({
      email: requiredEmail(t),
      dialCode: requiredDialCode(t),
      phoneNumber: requiredPhoneNumber(t),
      relation: z.nativeEnum(Relation).optional(),
    })
    .refine(phoneValidation, {
      message: t('INVALID_PHONE_NUMBER'),
      path: ['phoneNumber'],
    })
    .refine((data) => !(selectedRole !== OnboardingDetailsRole.BORROWER && !data.relation), {
      message: t('REQUIRED_FIELD'),
      path: ['relation'],
    });

export type ContactDataFormType = z.infer<ReturnType<typeof ContactDataFormSchema>>;
